module.exports = __webpack_public_path__ + "static/media/Tinkof.121ff6ec.svg";